export type HourlyApplicableRange = {
  minMinute: number;
  maxMinute: number;
};

export function isHourlyWeekOutOfRange(week: {
  minutes?: number;
  applicableRange?: HourlyApplicableRange | null;
}): boolean {
  return (week.minutes ?? 0) > 0 && !week.applicableRange;
}

export function resolveHourlySessionApplicableRange(params: {
  weeklyBreakdown?: Array<{
    minutes?: number;
    applicableRange?: HourlyApplicableRange | null;
  }>;
  sessionRange?: HourlyApplicableRange | null;
  groupRange?: HourlyApplicableRange | null;
}): HourlyApplicableRange | null {
  const weekWithRange = (params.weeklyBreakdown ?? []).find(
    (week) => week.applicableRange,
  );
  return (
    weekWithRange?.applicableRange ??
    params.sessionRange ??
    params.groupRange ??
    null
  );
}

export function isHourlySessionOutOfRange(params: {
  weeklyBreakdown?: Array<{
    minutes?: number;
    applicableRange?: HourlyApplicableRange | null;
  }>;
  sessionRange?: HourlyApplicableRange | null;
  groupRange?: HourlyApplicableRange | null;
}): boolean {
  if (resolveHourlySessionApplicableRange(params)) {
    return false;
  }
  return (params.weeklyBreakdown ?? []).some((week) => (week.minutes ?? 0) > 0);
}
